"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initEvents = void 0;
const domElements_1 = require("./domElements");
const handleBotones_1 = require("./handleBotones");
const initEvents = () => {
    domElements_1.btnCapturarDocumentos.addEventListener('click', handleBotones_1.handleBtnCapturarDocumentos);
    domElements_1.btnIniciarCamaraDocFrontal.addEventListener('click', handleBotones_1.handleIniciarCamaraDocFrontal);
    domElements_1.btnIniciarCamaraDocPosterior.addEventListener('click', handleBotones_1.handleIniciarCamaraDocPosterior);
    domElements_1.btnCapturarDocFrontal.addEventListener('click', handleBotones_1.handlebtnCapturarDocFrontal);
    domElements_1.btnReintentarDocFrontal.addEventListener('click', handleBotones_1.handleReintentarDocFrontal);
    domElements_1.btnConfirmarDocFrontal.addEventListener('click', handleBotones_1.handleConfirmarDocFrontal);
    domElements_1.btnCapturarDocPosterior.addEventListener('click', handleBotones_1.handlebtnCapturarDocPosterior);
    domElements_1.btnReintentarDocPosterior.addEventListener('click', handleBotones_1.handleReintentarDocPosterior);
    domElements_1.btnConfirmarDocPosterior.addEventListener('click', handleBotones_1.handleConfirmarDocPosterior);
    domElements_1.btnConfirmarPermiso.addEventListener('click', handleBotones_1.handleBtnConfirmarPermiso);
    domElements_1.btnEnviar.addEventListener('click', handleBotones_1.handleBtnEnviar);
    domElements_1.btnReintentarVerificacion.addEventListener('click', handleBotones_1.handleBtnReintentarVerificacion);
    domElements_1.btnContinuarRedireccion.addEventListener('click', () => (0, handleBotones_1.handleBtnContinuarRedireccion)());
};
exports.initEvents = initEvents;
